let keys = "";
if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === ""
) {
  keys = "http://localhost:3002";
} else if (window.location.hostname === "pay.goola.run") {
  keys = "https://gapi.goola.run";
} else if (window.location.hostname === "d18psq8exj9g9a.cloudfront.net") {
  keys = "https://staging.gapi.goola.run";
}

export default keys;
